module.exports = __webpack_public_path__ + "img/KarlusMorales_Isotype_Dark.39671b61.svg";